/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrends.defs.js'
export { main as default } from './getTrends.defs.js'
